"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var mcc_1 = __importDefault(require("../utils/mcc"));
var validateMcc = function (value) {
    var mcc = Number(value);
    for (var _i = 0, _a = Object.keys(mcc_1.default); _i < _a.length; _i++) {
        var key = _a[_i];
        if (mcc_1.default[key] === mcc) {
            return false;
        }
    }
    return 'Ramo do negócio não encontrado';
};
exports.default = validateMcc;
//# sourceMappingURL=mcc.js.map